module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226712192_07_ill#list"
    }
  }, [_vm._v("List of Illustrations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226712192_08_pre#pre"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226712192_09_ch1#ch1"
    }
  }, [_vm._v("1. Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226712192_09_ch1#lev1"
    }
  }, [_vm._v("The Tragic Source of the Anti-Religious Character of Evolutionary Theory")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226712192_10_ch2#ch2"
    }
  }, [_vm._v("2. Formation of a Romantic Biologist")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226712192_10_ch2#lev2"
    }
  }, [_vm._v("Early Student Years")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226712192_10_ch2#lev3"
    }
  }, [_vm._v("University Years")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226712192_10_ch2#lev4"
    }
  }, [_vm._v("Habilitation and Engagement")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226712192_11_ch3#ch3"
    }
  }, [_vm._v("3. Research in Italy and Conversion to Darwinism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226712192_11_ch3#lev5"
    }
  }, [_vm._v("Friendship with Allmers and Temptations of the Bohemian Life")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226712192_11_ch3#lev6"
    }
  }, [_vm._v("Radiolarians and the Darwinian Explanation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226712192_11_ch3#lev7"
    }
  }, [_vm._v("Appendix: Haeckel’s "), _c('em', [_vm._v("Challenger")]), _vm._v(" Investigations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_12_ch4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Triumph and Tragedy at Jena")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_12_ch4#lev8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Habilitation and Teaching")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_12_ch4#lev9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Friendship with Gegenbaur")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_12_ch4#lev10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For Love of Anna")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_12_ch4#lev11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Defender of Darwin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_12_ch4#lev12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tragedy in Jena")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226712192_13_ch5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Evolutionary Morphology in the Darwinian Mode")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_13_ch5#lev13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Haeckel’s "), _c('em', [_vm._v("Generelle Morphologie der Organismen")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_13_ch5#lev14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Haeckel’s Darwinism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_13_ch5#lev15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reaction to Haeckel’s "), _c('em', [_vm._v("Generelle Morphologie")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_13_ch5#lev16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_13_ch5#lev17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix: Haeckel’s Letter to Darwin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_14_ch6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Travel to England and the Canary Islands: Experimental Justification of Evolution")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_14_ch6#lev18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Visit to England and Meeting with Darwin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_14_ch6#lev19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Travel to the Canary Islands")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_14_ch6#lev20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Research on Siphonophores")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_14_ch6#lev21",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Entwickelungsmechanik")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_14_ch6#lev22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Polymorphous Sponge: The Analytical Evidence for Darwinian Theory")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_14_ch6#lev23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: A Naturalist Voyaging")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_15_ch7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. The Popular Presentation of Evolution")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_15_ch7#lev24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Haeckel’s "), _c('em', [_vm._v("Natural History of Creation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_15_ch7#lev25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: Evolutionary Theory and Racism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_16_ch8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. The Rage of the Critics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_16_ch8#lev26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Critical Objections and Charges of Fraud")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_16_ch8#lev27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Haeckel’s Responses to His Critics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_16_ch8#lev28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Epistemology of Photograph and Fact: Renewed Charges of Fraud")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_16_ch8#lev29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Munich Confrontation with Virchow: Science vs. Socialism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_16_ch8#lev30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_17_ch9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. The Religious Response to Evolutionism: Ants, Embryos, and Jesuits")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_17_ch9#lev31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Haeckel’s Journey to the Tropics: The Footprint of Religion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_17_ch9#lev32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Science Has Nothing to Do with Christ”—Darwin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_17_ch9#lev33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Erich Wasmann, a Jesuit Evolutionist")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_17_ch9#lev34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Keplerbund vs. the Monistenbund")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_17_ch9#lev35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Response of the Forty-six")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_17_ch9#lev36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226712192_18_ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Love in a Time of War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_18_ch10#lev37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("At Long Last Love")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_18_ch10#lev38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The World Puzzles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_18_ch10#lev39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Consolations of Love")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_18_ch10#lev40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Second Journey to the Tropics—Java and Sumatra")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_18_ch10#lev41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Growth in Love and Despair")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_18_ch10#lev42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lear on the Heath")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_18_ch10#lev43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Great War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_19_ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Conclusion: The Tragic Sense of Ernst Haeckel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_19_ch11#lev44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Early Assessments of Haeckel Outside of Germany")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_19_ch11#lev45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Haeckel in the English-Speaking World at Midcentury")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_19_ch11#lev46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Haeckel Scholarship in Germany (1900–Present)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_19_ch11#lev47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Contemporary Evaluation: Haeckel and the Nazis Again")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_19_ch11#lev48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Tragedy of Haeckel’s Life and Science")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1t"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_20_app1#lev49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 1: A Brief History of Morphology")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_20_app1#lev50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Johann Wolfgang von Goethe (1749–1832)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_20_app1#lev51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Karl Friedrich Burdach (1776–1847)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_20_app1#lev52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lorenz Oken (1779–1851)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_20_app1#lev53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Friedrich Tiedemann (1781–1861)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_20_app1#lev54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Carl Gustav Carus (1789–1869)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_20_app1#lev55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Heinrich Georg Bronn (1800–1862)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_20_app1#lev56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Karl Ernst von Baer (1792–1876)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_20_app1#lev57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Richard Owen (1804–1892)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_20_app1#lev58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Charles Darwin (1809–1882)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1t"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_21_app2#lev59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 2: The Moral Grammar of Narratives in the History of Biology—the Case of Haeckel and Nazi Biology")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_21_app2#lev60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction: Scientific History")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_21_app2#lev61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Temporal and Causal Grammar of Narrative History")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_21_app2#lev62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Moral Grammar of Narrative History")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_21_app2#lev63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Case of Ernst Haeckel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_21_app2#lev64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Moral Indictment of Haeckel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_21_app2#lev65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nazi Race Hygienists and Their Use of Haeckelian Ideas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226712192_21_app2#lev66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Judgment of Historical Responsibility")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_21_app2#lev67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Reaction of Contemporary Historians")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_21_app2#lev68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Principles of Moral Judgment")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_21_app2#lev69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1t"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_23_not#not",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_22_bib#bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226712192_24_ind#ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ba7140e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780226712192_06_toc.vue
// module id = 69
// module chunks = 0